










































































import Vue from 'vue'
import Component from 'vue-class-component'
import DeletePaymentMethodModal from '@/views/resident-portal/components/DeletePaymentMethodModal.vue'
import DeletePaymentMethodErrorModal from '@/views/resident-portal/components/DeletePaymentMethodErrorModal.vue'
import PaymentMethodModal from '@/components/modals/PaymentMethodModal.vue'
import { EPaymentMethodType, EUserPermissions, IResidentPaymentMethod } from '@zunta/configurations'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import CreditCard from '@/components/CreditCard.vue'
import ECheckCard from '@/components/eCheckCard.vue'
import ScrollView from '@/components/ScrollView.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import NoData from '@/views/app/management/residents/NoData.vue'
import NoRows from '@/components/tables/NoRows.vue'

@Component({
  components: {
    NoRows,
    LoaderWrapper,
    ScrollView,
    ECheckCard,
    CreditCard,
    Card,
    NoData,
    PaymentMethodModal,
    DeletePaymentMethodErrorModal,
    DeletePaymentMethodModal
  }
})
export default class ResidentPaymentMethods extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  user: User = Api.getUser() as User

  EUserPermissions: any = EUserPermissions
  EPaymentMethodType: any = EPaymentMethodType

  editPaymentData: IResidentPaymentMethod | null = null
  isDeletePaymentMethodErrorModalOpen: boolean = false
  paymentMethodModalVisible: boolean = false
  cardIdToBeDeleted: number | null = null
  isLoading: boolean = false

  get residentId () {
    return this.$route.params.id
  }

  get resident () {
    return this.$store.state.resident.selectedResident
  }

  get ccDisabled () {
    if (this.resident && !this.resident.facility.allowCCProcessing) {
      return true
    }
    return false
  }

  get paymentMethods () {
    let methods = this.$store.state.resident.paymentMethods
    if (this.ccDisabled) {
      methods = methods.filter((pm: IResidentPaymentMethod) => pm.type !== EPaymentMethodType.CREDIT_CARD)
    }
    methods.sort((x: any, y: any) => (x.isPrimary === y.isPrimary) ? 0 : x.isPrimary ? -1 : 1)
    return methods
  }

  get ccPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => {
      return paymentMethod.type === EPaymentMethodType.CREDIT_CARD
    })
  }

  get echeckPaymentMethods () {
    return this.paymentMethods.filter((paymentMethod: IResidentPaymentMethod) => {
      return paymentMethod.type === EPaymentMethodType.ECHECK
    })
  }

  mounted () {
    this.fetchPaymentMethods()
    this.$watch('$route', () => this.fetchPaymentMethods())
  }

  async fetchPaymentMethods () {
    try {
      this.isLoading = true
      await this.residentModuleInstance.getResidentPaymentMethods(this.residentId)
    } finally {
      this.isLoading = false
    }
  }

  async makePrimaryPaymentMethod (id: number): Promise<void> {
    await this.residentModuleInstance.makePaymentMethodPrimary({ residentId: this.residentId, paymentMethodId: id })
    await this.fetchResidentHistory()
  }

  async deletePaymentMethod (paymentMethodId: number) {
    this.closeDeletePaymentMethodModal()
    const response = await this.residentModuleInstance.deletePaymentMethod(paymentMethodId)
    if (response === 'OK') {
      await this.fetchResidentHistory()
    } else {
      this.openDeletePaymentMethodErrorModal()
    }
  }

  async makePaymentMethodPrimary (paymentMethodId: number): Promise<void> {
    await this.residentModuleInstance.makePaymentMethodPrimary({
      residentId: this.residentId,
      paymentMethodId
    })
    await this.fetchResidentHistory()
  }

  fetchResidentHistory () {
    this.$emit('updated')
  }

  showPaymentModal () {
    if (this.user.hasPermissionFor(EUserPermissions.MODIFY_PAYMENT_METHOD) || this.user.isResident()) {
      this.paymentMethodModalVisible = true
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: `Modify Resident Payment Method`,
        icon: 'warning'
      })
    }
  }

  openEditModal (id: number): void {
    this.editPaymentData = this.paymentMethods.find((pm: IResidentPaymentMethod) => pm.id === id)
    this.showPaymentModal()
  }

  closePaymentMethodModal (): void {
    this.paymentMethodModalVisible = false
    this.editPaymentData = null
    this.fetchResidentHistory()
  }

  openDeletePaymentMethodModal (id: number): void {
    this.cardIdToBeDeleted = id
  }

  closeDeletePaymentMethodModal () {
    this.cardIdToBeDeleted = null
  }

  openDeletePaymentMethodErrorModal () {
    this.isDeletePaymentMethodErrorModalOpen = true
  }

  closeDeletePaymentMethodErrorModal () {
    this.isDeletePaymentMethodErrorModalOpen = false
  }
}

